import { api } from "./UrlPadrao"

export const getPainel = async (token) => {
  return api.get("Painel",
  {
    headers: {
      'Authorization': token
    }
  })
}